import Service from "@/services/empresa.service"
import { Pagamento, PagePagamentoInput } from '@/models/pagamento'
import { PageEmpresaInput } from '@/models/empresa'

const emptyDetail = () => ({
  id: null as number,
  name: "",
  cnpj: "",
  email: "",
  cell_phone: "",
  address: {
    address: "",
    number: "",
    complement: "",
    zipcode: "",
    district: "",
    city: "",
    state: ""
  }
})


export const empresa = {
  namespaced: true,
  state: {
    table: {
      header: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id"
        },
        {
          text: "Empresa",
          align: "start",
          sortable: false,
          value: "name"
        },
        {
          text: "CNPJ",
          align: "start",
          sortable: false,
          value: "cnpj"
        },
        {
          text: "Email",
          align: "start",
          sortable: false,
          value: "email"
        },
        {
          text: "Telefone",
          align: "start",
          sortable: false,
          value: "cell_phone"
        },
        {
          text: "Token",
          align: "start",
          sortable: false,
          value: "token"
        },
        {
          text: "Criado em",
          align: "start",
          sortable: false,
          value: "created_at.formatted"
        },
        {
          text: "Ações",
          align: "start",
          sortable: false,
          value: "actions",
          width: "80px"
        },
      ],
      content: [] as Array<Pagamento>,
      paginate: {
        input: {
          name: "",
          cnpj: ""
        },
        inputPage: {
          page: 1,
          per_page: 10,
          sort: 'id:desc',
        },
      },
      isLoading: false,
      total: 0
    },
    detail: {
      data: emptyDetail(),
      isLoading: false
    },
  },
  mutations: {
    setDetail(state: any, value: any): void {
      state.detail.data = { ...emptyDetail(), ...value, address: { ...emptyDetail().address, ...(value?.address || {}) } }
    },
    setDetailIsLoading(state: any, value: boolean): void {
      state.detail.isLoading = value
    },
    setTableIsLoading(state: any, value: boolean): void {
      state.table.isLoading = value
    },
    setTableContent(state: any, value: Pagamento[]): void {
      state.table.content = value
    },
    setTableTotal(state: any, value: number): void {
      state.table.total = value
    },
    setTablePaginate(state: any, value: PageEmpresaInput): void {
      state.table.paginate = value
    },
  },
  actions: {
    SEARCH({ commit, dispatch, state }: any): void {
      commit('setTableIsLoading', true)
      Service.list(state.table.paginate).subscribe(({ items, totalItems }) => {
        commit('setTableContent', items)
        commit('setTableTotal', totalItems)
        commit('setTableIsLoading', false)
      }, (error) => {
        commit('setTableIsLoading', false)
      })
    },
    CHANGE_PAGE({ commit, dispatch, state }: any, value: PagePagamentoInput): void {
      commit('setTablePaginate', value)
    },
    CLEAR({ commit }: any): void {
      commit('setTableContent', [])
      commit('setTableTotal', 0)
      commit('setTableIsLoading', false)
      commit('setTablePaginate', {
        input: {
          name: "",
          cnpj: ""
        },
        inputPage: {
          page: 1,
          per_page: 10,
          sort: 'id:desc',
        },
      })
    },
    async SHOW({ commit }: any, value: number): Promise<any> {
      commit('setDetailIsLoading', true)
      try {
        const res = await Service.show(value).toPromise()
        commit('setDetail', res)
      } finally {
        commit('setDetailIsLoading', false)
      }
    },
    CLEAR_DETAIL({ commit }: any): void {
      commit('setDetail', {})
      commit('setDetailIsLoading', false)
    },
    // O service já envolve o corpo em { company: ... }; aqui só traduzimos
    // `address` (como vem do serializer) para `address_attributes`, que é o
    // nome esperado pelo strong params do controller.
    UPDATE({ commit }: any, { id, email, cell_phone, address }: any): void {
      commit('setDetailIsLoading', true)
      const payload = { email, cell_phone, address_attributes: { ...address } }
      Service.update(id, payload).subscribe((res: any) => {
        commit('setDetail', res)
        commit('setDetailIsLoading', false)
        commit("global/setSnackBar", { show: true, message: "Transportadora atualizada com sucesso", type: "success" }, { root: true })
      }, () => {
        commit('setDetailIsLoading', false)
      })
    },
  },
}
